"use client";

import React, { useState } from "react";
import { useAuth } from "./AuthProvider";
// import { toast } from "react-toastify";

import styles from "./admin.module.scss";

const Login: React.FC = () => {
	const [identifier, setIdentifier] = useState("");
	const [password, setPassword] = useState("");
	const [isLoading, setIsLoading] = useState(false);

	const { login, isAuthenticated } = useAuth(); // Verwende den Auth-Context

	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		setIsLoading(true);

		try {
			await login(identifier, password); // Rufe die Login-Funktion aus dem AuthContext auf
			setIsLoading(false);
		} catch (e) {
			console.warn(e);
			// toast.error("Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Anmeldeinformationen.");
			setIsLoading(false);
		}
	};

	if (isAuthenticated) {
		return <div>Sie sind eingeloggt!</div>;
	}

	return (
		<div className={styles.loginContainer}>
			<h2>Login</h2>
			<form onSubmit={handleSubmit}>
				<div className={styles.formGroup}>
					<label htmlFor="identifier">Benutzername oder E-Mail</label>
					<input type="text" id="identifier" value={identifier} onChange={(e) => setIdentifier(e.target.value)} placeholder="Benutzername oder E-Mail" required />
				</div>

				<div className={styles.formGroup}>
					<label htmlFor="password">Passwort</label>
					<input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Passwort" required />
				</div>

				<button type="submit" disabled={isLoading}>
					{isLoading ? "Anmeldung..." : "Anmelden"}
				</button>
			</form>
		</div>
	);
};

export default Login;
